import React from "react";

const Loading = () => {
  return (
    <div className="loadingContainer">
      <div className="loading">
        <div className="loadingOverlay"></div>
        <span className={`loader-spinner light`}></span>
      </div>
    </div>
  );
};

export default Loading;
